import { ColDef } from 'ag-grid-community';
import { format } from 'date-fns';
import { Workflow } from '~/atoms/workflowsAtoms';

// This type must be defined here to avoid circular imports
export type { Workflow };

export type ActionCellRendererParams = {
  data: Workflow;
  onSelect: (workflow: Workflow) => void;
};

export const getColDefsWorkflowTable = (params: {
  onWorkflowSelect: (workflow: Workflow) => void;
}): ColDef<Workflow>[] => [
  {
    field: 'priority',
    headerName: 'Priority',
    sortable: true,
    filter: true,
    width: 50,
    maxWidth: 200,
    cellClass: 'flex align-items-center',
    cellRenderer: 'priorityCellRenderer',
    suppressSizeToFit: true,
  },
  {
    field: 'started_at',
    headerName: 'Date',
    sortable: true,
    filter: 'agDateColumnFilter',
    cellClass: 'flex align-items-center',
    maxWidth: 150,
    sort: 'desc',
    valueFormatter: (p) =>
      p.value ? format(new Date(p.value), 'yyyy-MM-dd HH:mm') : '-',
  },
  {
    field: 'data.from_address',
    headerName: 'From',
    sortable: true,
    width: 110,
    filter: true,
    resizable: true,
    cellClass: 'flex align-items-center',
  },
  {
    field: 'data.subject',
    headerName: 'Subject',
    sortable: true,
    filter: true,
    tooltipField: 'data.subject',
    resizable: true,
    cellClass: 'flex align-items-center',
  },
  {
    field: 'status',
    headerName: 'Status',
    sortable: true,
    filter: true,
    resizable: true,
    width: 110,
    maxWidth: 110,
    cellClass: 'flex align-items-center',
    cellRenderer: 'statusCellRenderer',
  },
  {
    headerName: 'Actions',
    sortable: false,
    filter: false,
    width: 100,
    maxWidth: 200,
    cellClass: 'flex align-items-center justify-content-center action-cell',
    cellRenderer: 'selectCellRenderer',
    cellRendererParams: {
      onSelect: params.onWorkflowSelect,
    },
  },
];
